// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'preview';

export const Component = () => (
  <g fill='currentColor'>
    <rect width='7' height='13' x='16.5' y='6' rx='1' />
    <path
      fillRule='evenodd'
      d='M13.5 7h-11v11h11zm-11-1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z'
    />
  </g>
);

export const viewBox = '0 0 25 25';
